import {ComponentRef, Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {merge} from 'rxjs';
import {filter} from 'rxjs/operators';
import {SlidePanelService} from '../../../slide-panel/slide-panel.service';

export interface HoverComponentRegistryEntry {
    componentRef: ComponentRef<any>;
    destroyFromGlobal(): void;
}

@Injectable({
    providedIn: 'root',
})
export class HoverComponentRegistryService {
    private readonly openDirectives = new Set<HoverComponentRegistryEntry>();

    constructor(
        slidePanelService: SlidePanelService,
        router: Router,
        modalService: NgbModal,
    ) {
        merge(
            slidePanelService.panelChange,
            router.events.pipe(filter(event => event instanceof NavigationStart)),
            modalService.activeInstances.pipe(filter(x => !!x.length)),
        ).subscribe(() => {
            this.destroyAllOpen();
        });
    }

    add(directive: HoverComponentRegistryEntry): void {
        this.openDirectives.add(directive);
    }

    delete(directive: HoverComponentRegistryEntry): void {
        this.openDirectives.delete(directive);
    }

    forEach(cb: (directive: HoverComponentRegistryEntry) => void): void {
        this.openDirectives.forEach(cb);
    }

    findAncestor(el: HTMLElement): HoverComponentRegistryEntry | null {
        let bestMatch: HoverComponentRegistryEntry | null = null;
        let bestElement: HTMLElement | null = null;

        for (const d of this.openDirectives) {
            const previewEl = d.componentRef?.location?.nativeElement as HTMLElement | undefined;
            if (!previewEl?.contains(el)) continue;

            if (!bestElement || bestElement.contains(previewEl)) {
                bestMatch = d;
                bestElement = previewEl;
            }
        }

        return bestMatch;
    }

    private destroyAllOpen(): void {
        Array.from(this.openDirectives).forEach(d => d.destroyFromGlobal());
    }
}
